<div class="relative">
  <tui-loader [overlay]="true" [showLoader]="loading">
    <div class="container">
      <!-- Header -->
      <div class="flex gap-3 border-b border-b-[#bb0021] pb-2">
        <button
          style="cursor: pointer"
          class="p-2"
          (click)="router.navigate(['/admin/sales'])"
        >
          <tui-svg
            src="tuiIconArrowLeftCircleLarge"
            style="color: black"
            class="hover:scale-110 transition-all duration-100"
          ></tui-svg>
        </button>
        <p class="flex items-center text-black text-[1.5rem] font-bold">
          Add Sale
        </p>
      </div>

      <!-- Form -->
      <div
        class="flex items-center justify-center xl:justify-normal mt-5 2xl:my-10 lg:ml-10"
      >
        <div class="w-full sm:w-[500px]">
          <form [formGroup]="form" (ngSubmit)="submit()">
            <!-- Date -->
            <div>
              <label class="text-black">Date</label>
              <tui-input-date
                [max]="currentDate"
                tuiTextfieldSize="l"
                [tuiTextfieldCleaner]="true"
                [tuiTextfieldLabelOutside]="true"
                class="tui-space_top-1"
                formControlName="date"
              >
                <input autocomplete="off" tuiTextfield />
              </tui-input-date>
            </div>

            <!-- Item -->
            <div class="mt-4">
              <label class="text-black">Item</label>

              <!-- Loader while inventory is fetching -->
              <div *ngIf="inventoryLoading" class="flex items-center mt-2">
                <tui-loader size="s" [showLoader]="true"></tui-loader>
                <span class="ml-2 text-gray-500">Loading inventory...</span>
              </div>

              <!-- Dropdown when items are ready -->
              <div
                *ngIf="
                  !inventoryLoading && availableItems.length > 0;
                  else noInventory
                "
              >
                <tui-select
                  formControlName="item"
                  tuiTextfieldSize="l"
                  class="w-full"
                  [stringify]="stringify"
                  [identityMatcher]="identityMatcher"
                >
                  Select Item
                  <ng-template tuiDataList>
                    <tui-data-list>
                      <button
                        *ngFor="let inv of availableItems"
                        tuiOption
                        [value]="inv"
                      >
                        {{ inv.name }} | LKR
                        {{ inv.price | number : "1.2-2" }} | Available:
                        {{ inv.quantity }}
                      </button>
                    </tui-data-list>
                  </ng-template>
                </tui-select>
              </div>

              <!-- No items available -->
              <ng-template #noInventory>
                <div *ngIf="!inventoryLoading" class="mt-2 text-red-500">
                  No inventory items available. Please add items to inventory
                  first.
                </div>
              </ng-template>
            </div>

            <!-- Quantity -->
            <div class="mt-4">
              <label class="text-black">Quantity</label>
              <tui-input-count
                formControlName="quantity"
                tuiTextfieldSize="l"
                [min]="1"
                [max]="form.get('item')?.value?.quantity || 1"
                [step]="1"
                class="tui-space_top-1 w-full"
                >Quantity
              </tui-input-count>
            </div>

            <!-- Total Price -->
            <div class="mt-4">
              <label class="text-black">Total Price (LKR)</label>
              <tui-input
                formControlName="price"
                tuiTextfieldSize="l"
                [tuiTextfieldLabelOutside]="true"
                class="tui-space_top-1"
              >
                Price
                <input
                  tuiTextfield
                  readonly
                  [value]="form.get('price')?.value | number : '1.2-2'"
                />
              </tui-input>
            </div>

            <!-- Payment Method -->
            <div class="mt-4">
              <label class="text-black">Payment Method</label>
              <tui-select
                formControlName="paymentMethod"
                [tuiTextfieldCleaner]="true"
                tuiTextfieldSize="l"
              >
                <tui-data-list-wrapper
                  *tuiDataList
                  [items]="paymentMethodOptions"
                ></tui-data-list-wrapper>
                Payment Type (Online/Cash)
              </tui-select>
            </div>

            <!-- Buttons -->
            <div class="flex gap-3 w-full mt-5">
              <div class="w-full h-full">
                <button
                  (click)="cancel()"
                  tuiButton
                  appearance="secondary"
                  type="button"
                  class="w-full h-full text-[#bb0021] hover:bg-[#faf0f2] hover:text-[#bb0021]"
                >
                  Cancel
                </button>
              </div>
              <div class="w-full">
                <button
                  tuiButton
                  type="submit"
                  [disabled]="loading"
                  class="w-full"
                >
                  <span class="text-white">Add Sale</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </tui-loader>
</div>
